import { Member } from './Member';
import { User } from './User';
import { Workspace } from './Workspace';

export type ResourceActivityResourceType =
    | 'alerts'
    | 'dashboards'
    | 'folders'
    | 'importedEntities'
    | 'investments'
    | 'lifecycles'
    | 'listViews'
    | 'lists'
    | 'memos'
    | 'pipelines'
    | 'reportComponents'
    | 'reports'
    | 'teams'
    | 'tasks';

export enum ResourceActivityEventType {
    ARCHIVED = 'Archived',
    COMMENTED = 'Commented',
    COLLABORATOR_ADDED = 'Collaborator Added',
    COLLABORATOR_REMOVED = 'Collaborator Removed',
    COLLABORATOR_UPDATED = 'Collaborator Updated',
    CREATED = 'Created',
    DELETED = 'Deleted',
    EXPORTED = 'Exported',
    IMPORTED = 'Imported',
    LINKED = 'Linked',
    MOVED = 'Moved',
    RESTORED = 'Restored',
    UPDATED = 'Updated',
    VERSION_CREATED = 'Version Created',
}

export interface ResourceActivity {
    id: string;
    workspace: Workspace;
    actor?: User;
    actorMember?: Member;
    resourceType: ResourceActivityResourceType;
    resourceId: string;
    parentResourceType?: ResourceActivityResourceType;
    parentResourceId?: string;
    eventType: ResourceActivityEventType;
    action: string;
    title: string;
    summary?: string;
    metadata?: Record<string, unknown>;
    changes?: Record<string, unknown>;
    createdAt: Date;
    updatedAt: Date;
}

export interface ResourceActivityPage {
    items: ResourceActivity[];
    nextCursor?: string;
    hasMore: boolean;
}
